<template>
    <img
        v-if="'internal' === clearing"
        src="@img/schloss_icon.png"
        :title="$t('publication.intern')"
    />
    <img
        v-else-if="'parents' === clearing"
        src="@img/eltern_icon.png"
        :title="$t('publication.parents')"
    />
    <img
        v-else-if="'web' === clearing"
        src="@img/website_icon.png"
        :title="$t('publication.kindergartenWebsite')"
    />
</template>

<script>
export default {
    props: {
        clearing: {
            type: String,
            required: true,
        },
    },
};
</script>
